import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FavoritesItem = React.forwardRef(({ children, className, depth, icon, style, ...rest }, ref) => {
  return (
    <div ref={ref} className={classNames('favorites-item', className)} style={style} {...rest}>
      {children}
    </div>
  );
});

FavoritesItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  depth: PropTypes.number,
  icon: PropTypes.string,
  style: PropTypes.object,
};

export default FavoritesItem;
